import { render, staticRenderFns } from "./findAdmin.vue?vue&type=template&id=dac5aca6&scoped=true&"
import script from "./findAdmin.vue?vue&type=script&lang=js&"
export * from "./findAdmin.vue?vue&type=script&lang=js&"
import style0 from "./findAdmin.vue?vue&type=style&index=0&id=dac5aca6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac5aca6",
  null
  
)

export default component.exports